import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ib-input-field" }
const _hoisted_2 = { class: "flex-row si-row" }
const _hoisted_3 = { class: "ib-input-field contact-fields" }
const _hoisted_4 = {
  key: 0,
  class: "ticket-agreement"
}
const _hoisted_5 = { class: "ib-summary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_email_opt_in = _resolveComponent("email-opt-in")!
  const _component_phone_number_input = _resolveComponent("phone-number-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_progress_button = _resolveComponent("progress-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createBlock(_component_info_box, {
    isActive: _ctx.isActive,
    onOnEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('onEdit')))
  }, {
    title: _withCtx(() => _cache[8] || (_cache[8] = [
      _createElementVNode("span", { class: "ib-title" }, "Customer Information", -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        class: "ib-form",
        onSubmit: _ctx.onSubmit,
        autocomplete: "off"
      }, {
        default: _withCtx(({ validate }) => [
          _createElementVNode("div", _hoisted_1, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Name", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_text_input, {
                placeholder: 'First Name',
                name: 'firstName',
                modelValue: _ctx.customer.FirstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer.FirstName) = $event)),
                validators: [_ctx.isRequired]
              }, null, 8, ["modelValue", "validators"]),
              _createVNode(_component_text_input, {
                placeholder: 'Last Name',
                name: 'lastName',
                modelValue: _ctx.customer.LastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.LastName) = $event)),
                validators: [_ctx.isRequired]
              }, null, 8, ["modelValue", "validators"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Contact Information", -1)),
            _createVNode(_component_text_input, {
              name: 'email',
              type: 'email',
              placeholder: 'Email',
              validators: [_ctx.isRequired, _ctx.validEmail, _ctx.hasEmailFailed],
              error: 'A valid email is required',
              modelValue: _ctx.customer.Email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.Email) = $event))
            }, null, 8, ["validators", "modelValue"]),
            _createVNode(_component_email_opt_in),
            _createVNode(_component_phone_number_input, {
              modelValue: _ctx.customerPhone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customerPhone) = $event)),
              onOnValidPhone: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleValidPhone($event))),
              onOnChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.customerPhone = $event))
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.useTicketing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_checkbox, {
                  checked: _ctx.textTickets,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.textTickets = !_ctx.textTickets), ["prevent","stop"]))
                }, null, 8, ["checked"]),
                _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                  _createElementVNode("span", { class: "fw-medium" }, "Text tickets"),
                  _createElementVNode("div", null, "Standard messaging rates may apply. Tickets are also included in the confirmation email.")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_progress_button, {
            onClick: validate,
            showLoader: _ctx.loading
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Next", -1)
            ])),
            _: 2,
            __: [12]
          }, 1032, ["onClick", "showLoader"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    summary: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.customer.FirstName) + " " + _toDisplayString(_ctx.customer.LastName), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.customer.Email), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.phoneNumStr), 1)
      ])
    ]),
    _: 1
  }, 8, ["isActive"]))
}